































































































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import {AuthTokenDto} from "@/oauth/AuthTokenDto";
import {getModule} from "vuex-module-decorators";
import {AuthStore} from "@/oauth/AuthStore";
import {User} from "@/oauth/User";
import {UserDto} from "@/oauth/UserDto";
import {types} from "sass";
import {Validation} from '@/utils/Validation';
import {AppUpdateVersionDto} from "@/dto/AppUpdateVersionDto";
import {AppUpdateVersion} from "@/entity/AppUpdateVersion";
import {TokenTime} from "@/oauth/TokenTime";
import KeShangSelect from "@/views/KeShangSelect.vue";
import {SecurityRequestBase} from "@/oauth/SecurityRequestBase";
import {RealTimeInfoStore} from "@/store/RealTimeInfoStore";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {NewLoginEntity} from "@/entity/NewLoginEntity";
import {NewLoginDto} from "@/dto/NewLoginDto";
import axios from "axios";
import {IopAuthorizationDto} from "@/dto/IopAuthorizationDto";


@Component({

  components: {},
})

export default class PersonalCenter extends Vue {
  ls = getModule(AuthStore);
  public dialog = false;
  public secondDialog = false;
  public logo = false;
  user = new User();
  private users: User[] = [];
  loading = false;
  useri = new User();
  checkStep1Already = false
  secondpassword = '';
  password = '';
  private Validation = Validation;
  userA = new User()
  accept = false;
  flag: boolean | undefined;
  thisMachineAppVersionCode = 15;
  destroyUserDialog = false;
  bdage = false;
  disable = false
  FeedBackDialog = false
  show = true;
  count = 0;
  TIME_COUNT = 60;
  timer = 0;
  rememberUserName = '';
  flagA: boolean | undefined
  flagB: boolean | undefined
  question = ""
  // saveUrl(){
  //   console.log(this.user)
  //   this.user.avatarUrl = this.url3
  //   UserDto.save(this.user)
  //   this.logo = false
  // }

  async submit() {
    const response = await IopAuthorizationDto.getAuthorization();
    if (response.resCode === 0) {
      // https://iop.yong-gang.cn/prod-api/app/woodpecker/api/add正式环境
      // http://10.36.8.67/stage-api/app/woodpecker/api/add测试环境
      axios.post('https://iop.yong-gang.cn/prod-api/app/woodpecker/api/add', {
        "createBy": this.ls.loginUser.username,
        "topicType": "体验类",
        "businessScenario": "永卓客商",
        "title": "永卓客商问题反馈",
        "question": this.question,
        "pagePath": null,
        "pageParams": null
      }, {
        headers: {
          'Authorization': response.authorization
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$q.notify({message: '提交成功', color: 'green'})
          this.FeedBackDialog = false
        } else {
          this.$q.notify({message: '提交失败', color: 'red'})
        }
      })
    } else {
      this.$q.notify({message: '提交失败', color: 'red'})
    }
  }

  async verificationCode(i: string) {
    if (i.length > 4) {
      return '验证码为4位数字'
    } else {
      return true
    }
  }

  async restPassword() {
    this.userA.username = this.user.username
    this.userA.code = this.user.code
    try {
      // const a = await AuthTokenDto.getTokenBySMSLogin(this.userA);
      const newLoginEntity = new NewLoginEntity();
      newLoginEntity.userName = this.userA.username;
      newLoginEntity.smsCode = this.userA.code
      newLoginEntity.reqFlag = '3'
      const res = await NewLoginDto.login(newLoginEntity)
      if (res.resCode !== '0') {
        this.$q.notify({message: res.resMsg, color: 'red'})
        this.loading = false
        return
      }
      const authToken = res.data;
      //todo:
      const tokenizer = new TokenTime();
      tokenizer.token = authToken.access_token;
      tokenizer.userid = this.user.username;
      tokenizer.version = KeShangSelect.thisMachineAppVersionCode.toString();
      tokenizer.sidemodel = localStorage.getItem("sidemodel");
      await SecurityRequestBase.post('/auth/updateTokenTime', tokenizer);
      this.flag = true
      this.rememberUserName = this.userA.username
      AuthTokenDto.save(authToken);
      return true
    } catch (e) {
      this.flag = false
      this.$q.notify({message: e, color: 'red'});
      return false;
    }
    // if (a) {a
    //
    // }else {
    //   this.$q.notify({message: '登录失败:' + '用户名密码错误，请重新输入', color: 'red'});
    //   this.flag = false
    //   return  false
    // }
  }

  async amending() {
    if (await this.restPassword()) {
      if (this.flag == true) {
        this.secondDialog = true
        this.checkStep1Already = true

      } else {
        this.secondDialog = false
        this.checkStep1Already = false
        this.$q.notify({message: '验证码错误', color: 'red'});
      }
    }
  }

  private async verification() {
    if (this.user.username === '') {
      this.$q.notify({type: 'negative', message: '请先输入手机号'})
    } else if (this.user.username === null) {
      this.$q.notify({type: 'negative', message: '请先输入手机号'})
    } else {
      const b = await UserDto.findByUsername1(this.user.username);
      if (!b) {
        this.$q.notify({type: 'negative', message: '手机号未注册，无法发送验证码'})
        this.show = true;
      } else {
        this.user.receiver = this.user.username;
        await AuthTokenDto.send(this.user.receiver);
        this.count = this.TIME_COUNT;
        this.show = !this.show;
        this.timer = window.setInterval(() => {
          if (this.count > 0 && this.count <= this.TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = 0;
          }
        }, 1000)
      }
    }
  }

  destroyUser() {
    this.destroyUserDialog = true
  }

  async destroyUserSure() {
    await UserDto.logOff(this.user.username)
    this.destroyUserDialog = false
    this.suc()
    localStorage.clear()
  }

  yhxy() {
    const str = "https://yzkstest.yong-gang.cn/#/yhxy"
    this.$router.push({name: 'iframe', params: {url: str}})
  }

  yszc() {
    const str = "https://yzkstest.yong-gang.cn/#/yszc"
    this.$router.push({name: 'iframe', params: {url: str}})
  }

  goToMap() {
    this.$router.push({name: 'mapContainer'})
  }

  goToSettings() {
    this.$router.push({name: 'commonlyUsedSettings'})
  }

  // firstDialog() {
  //   this.user.password = '';
  //   this.dialog = false
  //
  // }

  async checkUpdate() {
    const win: any = window;
    const webkit = win.webkit;
    const ua = navigator.userAgent.toLowerCase();
    //android终端
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    //ios终端
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //ios
      console.log("ios")
      const appleVersion = new AppUpdateVersion()
      appleVersion.appSystem = '1'
      const a = await AppUpdateVersionDto.findLastAppSystemInformation(appleVersion)
      if ((this.thisMachineAppVersionCode < a.appVersionCode)) {
        window.location.href = a.appUrl;
      } else {
        this.$q.notify("Apple已是最新版本")
      }
    } else if (/(Android)/i.test(navigator.userAgent)) {
      //android
      console.log("android")
      const appleVersion = new AppUpdateVersion()
      appleVersion.appSystem = '0'
      const a = await AppUpdateVersionDto.findLastAppSystemInformation(appleVersion)
      console.log(a.appVersionCode);
      if ((this.thisMachineAppVersionCode < a.appVersionCode)) {
        window.location.href = a.appUrl;
      } else {
        this.$q.notify("Android已是最新版本")
      }
    }
  }

  async autoCheckUpdate() {
    const win: any = window;
    const webkit = win.webkit;
    const ua = navigator.userAgent.toLowerCase();
    //android终端
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    //ios终端
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //ios
      console.log("ios")
      const appleVersion = new AppUpdateVersion()
      appleVersion.appSystem = '1'
      const a = await AppUpdateVersionDto.findLastAppSystemInformation(appleVersion)
      if ((this.thisMachineAppVersionCode < a.appVersionCode)) {
        this.bdage = true;
      }
    } else if (/(Android)/i.test(navigator.userAgent)) {
      //android
      console.log("android")
      const appleVersion = new AppUpdateVersion()
      appleVersion.appSystem = '0'
      const a = await AppUpdateVersionDto.findLastAppSystemInformation(appleVersion)
      console.log(a.appVersionCode);
      if ((this.thisMachineAppVersionCode < a.appVersionCode)) {
        this.bdage = true;
      }
    }
  }

  async handleSubmit() {
    this.loading = true
    try {
      if (this.flagA) {
        await this.store()
      } else {
        this.secondDialog = false
        this.password = ''
        this.secondpassword = ''
        this.user.code = ''
        window.localStorage.removeItem("AuthToken");
        this.flag = this.flagB
        this.$q.notify({message: '密码输入不一致'});
      }
    } catch (e) {
      this.$q.notify("找不到对象")

    } finally {
      this.loading = false
    }
  }

  async store() {

    this.user.password = this.password
    console.log(this.user)
    await UserDto.save(this.user)
    this.dialog = false
    this.checkStep1Already = false
    this.secondDialog = false;
    this.secondpassword = '';
    this.password = '';
    this.user.password = '';
    AuthTokenDto.logout();
    this.$router.push({name: 'login'});
    this.$q.notify({type: 'positive', message: '修改密码成功'});
    const tokenizer = new TokenTime();
    tokenizer.token = '';
    tokenizer.userid = this.user.username;
    tokenizer.version = KeShangSelect.thisMachineAppVersionCode.toString();
    tokenizer.sidemodel = localStorage.getItem("sidemodel");
    await SecurityRequestBase.post('/auth/updateTokenTime', tokenizer);
    // const user = await UserDto.findByUsername(AuthTokenDto.getOrLogin().getUsername());
    // user.password = this.password
  }

  matching() {
    if (this.password === this.secondpassword) {
      this.flagA = true
      return true
    } else return '密码输入有误';
  }

  async handleLicense(e: { xhr: XMLHttpRequest }) {
    const url = e.xhr.responseText
    // const url1 = url.replace("http", "https")
    const url2 = url.replace("ygpubfile.yong-gang.cn:80", "ygpubfile.yong-gang.cn")
    // this.user.avatarUrl = url2;
    this.userA = await UserDto.findByUsername(this.user.username)
    this.userA.avatarUrl = url2
    await UserDto.save(this.userA)
    // UserDto.save(this.userA)
    location.reload();
  }


  async suc() {
    AuthTokenDto.logout();
    this.$router.push({name: 'login'});
    // localStorage.removeItem("name")
    // localStorage.removeItem("passWorld")
    // localStorage.removeItem("checked")
    localStorage.removeItem("AuthToken")
    localStorage.removeItem("demo1")
    localStorage.removeItem("user")
    localStorage.removeItem("friendList")
    localStorage.removeItem('infoReal')
    localStorage.removeItem("selectedCompanyInfo");
    localStorage.removeItem("companyList");
    localStorage.removeItem("appList");
    await getModule(RealTimeInfoStore).setCurrentRealInfos([])
    await getModule(RealTimeInfoStore).setQueryInfo(new UserInfoEntity())
  }

  private dateFormat(time: number) {
    const date = new Date(time);
    const year = date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    const month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    // const hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
    // const minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
    // const seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
    // 拼接
    return year + "-" + month + "-" + day + " ";
  }

  get userName() {
    return this.ls.loginUser.username
  }

  get passWorld() {
    // console.log(this.ls.loginUser.password)
    return this.ls.loginUser.password
  }

  get Name() {
    return this.ls.loginUser.name
  }


  // get lastLoginDate() {
  //   return this.ls.loginUser.lastLoginDate
  // }
  goWoodpecker() {
    this.FeedBackDialog = true
  }

  fanghui() {
    this.$router.push("/keShangSelect")
  }

  save() {
    // getModule(AuthStore).setLoginUser(this.user);
    // console.log(this.user.password)
    UserDto.save(this.user);
    this.$q.notify({message: '成功'});
    this.dialog = false
    // const  users =  UserDto.findByUsername(this.ls.loginUser.username)
    // console.log(users)
  }

  async findAll() {
    const user = await UserDto.findByUsername(this.ls.loginUser.username)
    this.user = user;
    // console.log(this.user)
  }


  private mounted() {
    this.findAll();
    this.autoCheckUpdate();

  }

}
